import { Inject, Injectable, InjectionToken } from '@angular/core';
import { WorkOrder } from 'src/app/interfaces/workorder';

export const WORKITEM_PRELOADER_TOKEN = new InjectionToken<WorkitemPreloader>('WorkitemPreloader');

export interface WorkitemPreloader {
  preload(workitem: WorkOrder): void;
  readonly workItemType: string;
}

@Injectable({
  providedIn: 'root'
})
export class WorkitemPreloadService {

  private preLoaders: Map<string, WorkitemPreloader> = new Map<string, WorkitemPreloader>();

  constructor(
    @Inject(WORKITEM_PRELOADER_TOKEN) loaders: WorkitemPreloader[]
  ) {
    loaders?.forEach(loader => this.preLoaders.set(loader.workItemType, loader));
  }

  public preloadWorkItem(workitem: WorkOrder) {
    let loader = this.preLoaders.get(workitem?.messageType);
    if(!!loader) loader.preload(workitem);
  }
}
